import { render, staticRenderFns } from "./AdminMenu.vue?vue&type=template&id=175ad200&scoped=true&"
import script from "./AdminMenu.vue?vue&type=script&lang=js&"
export * from "./AdminMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenu.vue?vue&type=style&index=0&id=175ad200&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175ad200",
  null
  
)

export default component.exports